import { CloudSun } from "lucide-react";
import { Card } from "../Card.js";
import { cn } from "../../lib/cn.js";

/**
 * The design's Weather panel, with no weather in it.
 *
 * Present because the layout is being ported one for one, empty because this
 * deployment has no source for it and cannot casually acquire one: the
 * production CSP is `connect-src 'self'`, so the browser cannot call a weather
 * API at all, and `REQUIREMENTS.md` section 1 lists weather integration as an
 * explicit non-goal. Filling it needs a decision record amending that section
 * and a server-side fetch, not a key in the client.
 *
 * The design's own figure here reads `Sunny 32.c`, which is a typo for 32°C.
 * Rather than reproduce a malformed unit, the panel states what it is waiting
 * for. The unit is written properly the day there is a temperature to put in
 * it.
 */
export function WeatherWidget({
  onExpand,
  className,
}: {
  onExpand?: () => void;
  className?: string;
}) {
  return (
    <Card
      onExpand={onExpand}
      title="Weather"
      className={cn("flex flex-col justify-between", className)}
    >
      <div className="mt-2 flex items-end justify-between pt-2">
        <div className="flex items-center justify-center rounded-2xl bg-line/60 p-3">
          <CloudSun size={36} aria-hidden="true" className="text-amber-400" />
        </div>

        <div className="text-right">
          <p className="tabular text-2xl font-bold tracking-tight text-ink-muted sm:text-3xl">
            &mdash;
          </p>
          <p className="mt-1 max-w-[18ch] text-xs font-medium text-ink-muted">
            No weather source is connected to this installation.
          </p>
        </div>
      </div>
    </Card>
  );
}
